import React from "react";
import { Box } from "@material-ui/core";

export default function Loading({ message }: { message?: string }) {
    return (
        <Box textAlign="center" component="h2">
            {/* <CircularProgress size={200}></CircularProgress> */}
            <img
                src="/images/GuideStream_AnimatedIcon.gif"
                alt="Guide Stream 360 Loading animation"
                style={{ maxHeight: "75%", maxWidth: "75%" }}
            />
            {message && (
                <>
                    <br />
                    <br /> {message}
                </>
            )}
        </Box>
    );
}
